import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  colors,
  IconButton,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import {
  ContentCopy,
} from '@mui/icons-material';

export type PropertyListItem = {
  key?: string;
  label: string;
  value?: React.ReactNode;
  copyable?: boolean;
  copyValue?: string;
};

export type PropertyListProps = {
  items: PropertyListItem[];
  columns?: number;
  highlightNulls?: boolean;
};

function PropertyList({
  items,
  columns = 1,
  highlightNulls = false,
}: PropertyListProps) {
  const maxColumns = Math.min(columns, 4);

  return (
    <Box
      sx={{
        display: 'grid',
        columnGap: 4,
        rowGap: 8,
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          sm: `repeat(${Math.min(maxColumns, 2)}, 1fr)`,
          md: `repeat(${Math.min(maxColumns, 3)}, 1fr)`,
          lg: `repeat(${maxColumns}, 1fr)`,
        },
      }}
    >
      {items.map((item, ind) => (
        <Box
          key={`item_${ind}`}
          className={`item-${item.key ?? ind.toString()}`}
        >
          <Stack spacing={1}>
            <Typography
              component='div'
              sx={{
                pb: 2,

                fontWeight: 'bold',
                textTransform: 'capitalize',
                color: (highlightNulls && !item.value) ? colors.red[600] : colors.grey[600]
              }}
            >
              {item.label.toLocaleLowerCase()}
            </Typography>
            <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
              <Typography
                component='div'
                sx={{
                  wordBreak: 'break-word',
                  textTransform: 'capitalize',
                  '& small': {
                    fontWeight: 'normal',
                    ml: 2,
                  }
                }}
              >
                {item.value ?? '--'}
              </Typography>
              {item.copyable && item.copyValue && (
                <CopyToClipboard text={item.copyValue}>
                  <IconButton>
                    <ContentCopy />
                  </IconButton>
                </CopyToClipboard>
              )}
            </Stack>
          </Stack>
        </Box>
      ))}
    </Box>
  );
}

export default PropertyList;
